import React from "react";
import { createBrowserRouter, Navigate } from "react-router-dom";
import App from "../App";

import AdminHome from "../pages/AdminHome";
import AdminLayout from "../components/AdminLayout";
import EnquiryTable from "../pages/EnquiryList";
import HomeBanner from "../pages/AdminHome";
import AddTestimonial from "../pages/TestimonialForm";
import TestimonialList from "../pages/TestimonialList";
import GalleryManagement from "../pages/GalleryManagement";
import PropertyForm from "../pages/PropertyForm";
import PropertyList from "../pages/PropertyList";
import SettingsPage from "../pages/SettingsPage";
import Login from "../pages/Login";
import ForgotPassword from "../pages/ForgotPassword";
import ResetPassword from "../pages/ResetPassword";
import NotFound from "../pages/NotFound";

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
      {
        index: true,
        element: <Login />,
      },
      {
        path: "login",
        element: <Login />
      },
      {
        path: "forgot-password",
        element: <ForgotPassword />
      },
      {
        path: "reset-password",
        element: <ResetPassword />
      },

      // ADMIN PANEL
      {
        path: "admin-panel",
        element: <AdminLayout/>,
        children: [
          {index:true, element: <Navigate to="admin-home" replace />},
          {
            path: "admin-home",
            element: <AdminHome/>,
          },
          {
           path:"enquiry-table",
           element:<EnquiryTable/>
          },{
            path:"home-banner",
            element:<HomeBanner/>
          },
          {
            path:"testimonial-list",
            element:<TestimonialList/>
          },
          {
            path:"testimonial-list/testimonial-form",
            element:<AddTestimonial/>
          },
          {
            path:"gallery-management",
            element:<GalleryManagement/>
          },
          {
             path:"property-list",
             element:<PropertyList/>
          },
          {
            path:"property-list/property-form",
            element:<PropertyForm/>
          },
          {
           path:"settings-page",
           element:<SettingsPage/>
          }
        ],
      },

      {
        path: "*",
        element: <NotFound />,
      },
    ],
  },
]);

export default router;